module.exports = __webpack_public_path__ + "img/hb.58b37089.png";